export const processBeyondNutrients = (beyond, nutrient) => {
  const isNegative = beyond[nutrient] < 0;
  const positiveValue = isNegative ? -beyond[nutrient] : beyond[nutrient];

  const value = positiveValue.toFixed(1);
  const overUnderText = isNegative ? 'under' : 'over';

  return { value, overUnderText };
};
